import { getCsrfValue } from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/wishlist/createOrUpdate");
export function sendData(data: { id: string; newName: string; description: string }) {
  return fetch(apiUrl, {
    body: JSON.stringify({
      id: data.id,
      wishlistName: data.newName,
      description: data.description,
    }),
    method: "POST",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
}
